import { DataSourceTypeDisplayNames } from "@coeff/utils";
import React from "react";
import styled from "styled-components";

import { Card, CardHeader, WheelIcon } from "../components";
import { useZendeskContext } from "../contexts/zendeskContext";

const { COLORS } = require("@coeff/utils");

const FAQ_LINKS: Record<string, string> = {
  snowflake: "https://coefficient.io/help-center/snowflake/faq?",
  mssql: "https://coefficient.io/help-center/mssql/faq?",
  azure_sql: "https://coefficient.io/help-center/mssql/faq?",
  mysql: "https://coefficient.io/help-center/mysql/faq?",
  postgres: "https://coefficient.io/help-center/postgresql/faq?",
  redshift: "https://coefficient.io/help-center/redshift/faq?",
  // Managed services point at their upstream engine's FAQ until they have dedicated pages.
  aurora_mysql: "https://coefficient.io/help-center/mysql/faq?",
  cloud_sql_mysql: "https://coefficient.io/help-center/mysql/faq?",
  aurora_postgres: "https://coefficient.io/help-center/postgresql/faq?",
  cloud_sql_postgres: "https://coefficient.io/help-center/postgresql/faq?",
  supabase: "https://coefficient.io/help-center/postgresql/faq?",
  neon: "https://coefficient.io/help-center/postgresql/faq?",
  timescaledb: "https://coefficient.io/help-center/postgresql/faq?",
  azure_postgres: "https://coefficient.io/help-center/postgresql/faq?",
  azure_mysql: "https://coefficient.io/help-center/mysql/faq?",
  clickhouse: "https://coefficient.io/help-center?",
};

const CardContent = styled.div`
  padding: 10px;
`;

const CardPanel = styled.div`
  margin-left: 24px;

  button {
    margin-top: 6px;
    padding: 0;
    background: none;
    border: none;
    font: inherit;
    color: ${COLORS.coeblue4};
    font-weight: 600;
    text-align: left;
    cursor: pointer;
  }
`;

export const ConnectionHelpCard: React.FC<{ dataSourceType: string }> = ({ dataSourceType }) => {
  const { openZendesk } = useZendeskContext();

  const faqLink = FAQ_LINKS[dataSourceType];

  return (
    <Card className="coeblue">
      <CardContent>
        <CardHeader icon={<WheelIcon />} title="Need help connecting?" />
        <CardPanel>
          {faqLink && (
            <button>
              <a href={faqLink} target="_blank" rel="noopener noreferrer">
                Connecting to {DataSourceTypeDisplayNames[dataSourceType]} guide
              </a>
            </button>
          )}
          <button onClick={() => openZendesk("ConnectionHelpCard")}>
            Chat with customer support
          </button>
        </CardPanel>
      </CardContent>
    </Card>
  );
};
